import React, { useEffect, useState } from "react";
import "./Cruise_Description.css";
import Cruise_Booking from "../cruise_booking/Cruise_Booking";
import Itinerary from "../itinerary/Itinerary";
import { getData } from "../../../../utils/api";

const Cruise_Description = ({ data }) => {
  const [packages, setPackage] = useState([]);

  const getPackageAll = async () => {
    const response = await getData(`/master/cruise-package/`);

    setPackage(response?.data);
  };

  useEffect(() => {
    getPackageAll();
  }, []);

  return (
    <div className="container cruise-main-container">
      <h4 className="section-title">Description</h4>

      <div
        className="description-text"
        dangerouslySetInnerHTML={{ __html: data?.description }}
      ></div>

      <h4 className="section-title">Trip Highlights</h4>

      <div dangerouslySetInnerHTML={{ __html: data?.highlights }}></div>
      <Itinerary data={data} />
    </div>
  );
};
export default Cruise_Description;
